<div class="modal-header">
    <h5 class="modal-title">
        Нова сесія
    </h5>
    <button
            type="button"
            class="close"
            (click)="onClose()"
    >
        <i class="bi bi-x-lg"></i>
    </button>
</div>
<div class="modal-body">
    <form>
        <div class="mb-5">
            <select class="form-control">
                <option>1</option>
            </select>
        </div>
        <div class="mb-2">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault1">
                <label class="form-check-label" for="flexCheckDefault1">
                    Призначити сесію
                </label>
            </div>

        </div>
        <div class="mb-5 row">
            <div class="col-md-6 col-12">
                <input class="form-control" placeholder="Виберіть тест">
            </div>
            <div class="col-md-6 col-12">
                <input class="form-control" placeholder="Виберіть зручний час ">
            </div>
        </div>

        <div class="mb-2">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                <label class="form-check-label" for="flexCheckDefault">
                    Призначити тест
                </label>
            </div>
        </div>
        <div class="mb-5 row">
            <div class="col-md-6 col-12">
                <button class="btn btn-outline-secondary">Тести Anima</button>
            </div>
            <div class="col-md-6 col-12">
                <button class="btn btn-primary">Всі тести</button>
            </div>
        </div>
        <div class="mb-5">
            <select class="form-control">
                <option selected disabled>Виберіть необіхідні тести та їх комбінації для сесії</option>
                <option>1</option>
            </select>
        </div>

        <div class="form-check mb-4">
            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault2">
            <label class="form-check-label" for="flexCheckDefault2">
                Я погоджуюся з умовами політики конфіденційності Anima і даю згоду на обробку моїх персональних даних на законних підставах.
            </label>
        </div>
        <button class="btn_primary hover_action" (click)="submit()">
            Призначити
            <i class="bi bi-chevron-right text-white"></i>
        </button>
    </form>
</div>
<div class="modal-footer flex-column">

</div>
